<div id="layout-wrapper" *ngIf="user.type !== 'user'">
  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()">
  </app-topbar>
  <app-sidebar></app-sidebar>
  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>

    <app-footer [user]="user"></app-footer>
  </div>
</div>
<!-- END layout-wrapper -->

<router-outlet *ngIf="user.type === 'user'">
</router-outlet>
